import { render, staticRenderFns } from "./AutomatorModeSwitch.vue?vue&type=template&id=15d9af9b&scoped=true"
import script from "./AutomatorModeSwitch.vue?vue&type=script&lang=js"
export * from "./AutomatorModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./AutomatorModeSwitch.vue?vue&type=style&index=0&id=15d9af9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9af9b",
  null
  
)

export default component.exports